






















































































import { Component, Vue } from "vue-property-decorator";
import { EchoPromise } from "echofetch";
import { Event } from "@/api/models/Event";
import EventService from "@/api/services/EventService";
import ErrorCard from "@/components/error/ErrorCard.vue";
import CalendarCard from "@/components/kalender/CalendarCard.vue";
import CalendarSyncDialog from "@/components/kalender/CalendarSyncDialog.vue";
import { dateFormat } from "@/plugins/dateformat";
import CalendarEventDialog from "@/components/kalender/CalendarEventDialog.vue";
import { Optional } from "@/types/Optional";

@Component({
    components: { CalendarEventDialog, CalendarSyncDialog, CalendarCard, ErrorCard }
})
export default class Kalender extends Vue {
    /**
     * List with events
     */
    events: EchoPromise<Event[]> = EventService.get();

    /**
     * If the sync dialog is open or not.
     */
    dialogSyncOpen = false;

    /**
     * If the event dialog is open or not.
     */
    dialogEventOpen = false;

    /**
     * The event to display inside the dialog.
     */
    dialogEvent: Optional<Event> = null;

    /**
     * Get a list with months that contain events.
     */
    get months() {
        if (this.events.isSuccess()) {
            const months = new Set();

            for (const event of this.events.requireData()) {
                months.add(dateFormat(new Date(event.startTime), "MMMM"));
            }

            return months;
        } else {
            return [];
        }
    }

    /**
     * Get the events for a given month.
     */
    getEventsForMonth(month: string): Event[] {
        return this.events.requireData().filter(event => dateFormat(new Date(event.startTime), "MMMM") === month);
    }

    /**
     * Open an event dialog for a given event.
     * @param event Event to open.
     */
    openEvent(event: Event) {
        this.dialogEvent = event;
        this.dialogEventOpen = true;
    }
}
